module.exports = __webpack_public_path__ + "static/img/KQJD.13b9db5b.png";